/* eslint-disable import/prefer-default-export */
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_MONTH = 'YYYY-MM';
export const UI_DATE_FORMAT = 'MMM DD, YYYY';
